import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";
import { FormBuilder } from '@angular/forms';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { AppEventNames } from "src/app-client/_appCommon/base/Constants";
import { BroadcastManager } from "src/app-client/_appCommon/base/BroadcastManager";
import { CaseWizardService } from '../../../../_dataservices/CaseWizardService';
import { CoordinateNumberAlignersType, CoordinateNumberAlignersTypeLabel, DescriptionByCoordinateNumberAlignersType } from "src/app-client/_appCommon/base/AppInterfaceAndBaseClasses";
import { FormTools } from "src/shared/util/FormTools";
import { PrescriptionDataService } from "src/app-client/_dataservices/PrescriptionDataService";
import { SetupDataService } from 'src/app-client/_dataservices/SetupDataService';

@Component({
  selector: 'app-client-nineth-step',
  templateUrl: './nineth-step.component.html',
  styleUrls: ['../crud-prescription.component.css'],
  providers: [PrescriptionDataService]
})
export class NinethStepComponent extends FormTools implements OnChanges
{
  @ViewChild('generatingPDFDialog') protected generatingPDFDialog: any;
  @ViewChild('generatingPDFErrorDialog') protected generatingPDFErrorDialog: any;

  private unsubscribe: Subject<void> = new Subject();

  public isCaseDetail: boolean;
  public loading = false;
  public prescriptionNumber = 9;
  public protocolDaysOptions = [15, 10, 7];
  public step9Valid = false;
  public coordinateNumberAlignersTypeOptions = [
    {
      value: CoordinateNumberAlignersType.Independent,
      display: CoordinateNumberAlignersTypeLabel.get(CoordinateNumberAlignersType.Independent),
      description: DescriptionByCoordinateNumberAlignersType.get(CoordinateNumberAlignersType.Independent) },
    {
      value: CoordinateNumberAlignersType.Coordinated,
      display: CoordinateNumberAlignersTypeLabel.get(CoordinateNumberAlignersType.Coordinated),
      description: DescriptionByCoordinateNumberAlignersType.get(CoordinateNumberAlignersType.Coordinated)
    },
  ];

  confirmCheckbox: boolean = false;

  @Input('prescriptionData') public prescriptionData! : any;

  constructor(
    formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private prescriptionDataService: PrescriptionDataService,
    public caseWizardService: CaseWizardService,
    private setupDataService: SetupDataService
  )
  {
    super(10, formBuilder);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['prescriptionData']){
      this.stepFormGroup?.controls['protocolDays'].setValue(changes['prescriptionData'].currentValue.protocolDays);
      this.stepFormGroup?.controls['sugestQuantityAligners'].setValue(changes['prescriptionData'].currentValue.sugestQuantityAligners);
      this.stepFormGroup?.controls['upperAlignersQuantity'].setValue(changes['prescriptionData'].currentValue.upperAlignersQuantity);
      this.stepFormGroup?.controls['lowerAlignersQuantity'].setValue(changes['prescriptionData'].currentValue.lowerAlignersQuantity);
      this.stepFormGroup?.controls['coordinateNumberAlignersType'].setValue(changes['prescriptionData'].currentValue.coordinateNumberAlignersType);
      this.stepFormGroup?.controls['protocolUseAlignersComments'].setValue(changes['prescriptionData'].currentValue.protocolUseAlignersComments);
    } 
  }

  ngOnInit(): void
  {
    this.activatedRoute.url.subscribe( url =>
    {
      this.isCaseDetail = url.toString().contains('detail');
    });

    BroadcastManager.Instance.on(AppEventNames.onUpdatePrescriptionStepByNumber)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([e]) =>
      {
        let number = e[0];

        if (number && this.prescriptionNumber == number)
          this.updateStepPrescription();
      });

      BroadcastManager.Instance.on('uncheck-confirmation')
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([e]) =>
      {
        this.confirmCheckbox = e[0];
        BroadcastManager.Instance.broadcast("step9Valid", e[0]);
      });

      
    BroadcastManager.Instance.on(AppEventNames.onGeneratePrescriptionDocument)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([e]) =>
      {
        if(e[0])
          this.generatePrescriptionDocument();
      });

    this.stepFormGroup = this.formBuilder.group({
      id: [0, null],
      protocolDays: [15, null],
      sugestQuantityAligners: [false, null],
      upperAlignersQuantity: [null, null],
      lowerAlignersQuantity: [null, null],
      coordinateNumberAlignersType: [CoordinateNumberAlignersType.Coordinated, null],
      protocolUseAlignersComments: ['', null]
    });
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public updateStepPrescription(): void
  {
    // Set prescriptionId in stepFormGroup
    this.stepFormGroup.controls['id'].setValue(this.GetPrescriptionId);

    this.prescriptionDataService.updatePrescriptionStep(this.GetSetupId, this.prescriptionNumber, this.stepFormGroup.value, this.GetCaseId)
      .subscribe((response) =>
      {
        let body = 
        {
          id: this.GetSetupId,
          currentStep: 2
        }
        this.updateSetupCurrentStep(body);
        this.setSuccessAlert('Paso guardado correctamente');
        this.loading = false;
        this.updateUseAlignersProtcol();

        BroadcastManager.Instance.broadcast(AppEventNames.onPrescriptionStepsSaved, true);
      }, fail =>
      {
        this.setWarningAlert('Hubo un error al actualizar la prescripción: '+ fail.error.message);
      });
  }

  private updateUseAlignersProtcol(): void
  {
    let useAlignersProtcolDataForm =
    {
      caseId: 0,
      setupId: this.GetSetupId,
      //upperAligners: this.stepFormGroup.controls['upperAlignersQuantity'].value ?? 0,
      //lowerAligners: this.stepFormGroup.controls['lowerAlignersQuantity'].value ?? 0,
      upperAligners: 0,
      lowerAligners: 0,
	    frecuencyDays: this.stepFormGroup.controls['protocolDays'].value,
    };

    BroadcastManager.Instance.broadcast(AppEventNames.onUpdateProtocolForUseAligners, useAlignersProtcolDataForm);

    if(this.isCaseDetail)
      this.generatePrescriptionDocument();
  }

  private generatePrescriptionDocument(): void
  {
    this.generatingPDFDialog.show = true;
    this.prescriptionDataService.generatePDF(this.GetPrescriptionId,this.GetCaseId)
      .subscribe((response) =>
      {
        if(response)
        {
          this.caseWizardService.urlPDF = response.path;
          this.generatingPDFDialog.show = false;
          BroadcastManager.Instance.broadcast(AppEventNames.onCompleteSetup, this.GetSetupId);
          BroadcastManager.Instance.broadcast(AppEventNames.onPrescriptionDocumentCreated, undefined);
        }
      }, err=>{
        this.generatingPDFDialog.show = false;
        this.generatingPDFErrorDialog.show = true;
        this.setDangerAlert('Hubo un error al generar el documento de la prescripción: '+ err.message);
      });
  }

  public onChangeSugestQuantityAligners(event: any): void
  {
    if (event)
    {
      this.stepFormGroup.controls['upperAlignersQuantity'].setValue(0);
      this.stepFormGroup.controls['lowerAlignersQuantity'].setValue(0);
    }
  }

  public get getShowSaveButton(): boolean
  {
    return this.stepFormGroup.valid && !this.loading;
  }

  public onCheckboxChange(e:any)
  {
    BroadcastManager.Instance.broadcast("step9Valid", e);
  }

  public get getValidTotalAlignersQuantity(): boolean
  {
    let notMinimalQuantity = null;
    let upperQuantity = this.stepFormGroup.controls['upperAlignersQuantity'].value;
    let lowerQuantity = this.stepFormGroup.controls['lowerAlignersQuantity'].value;

    if (upperQuantity != null || lowerQuantity != null)
    {
      notMinimalQuantity = (upperQuantity || 0) + (lowerQuantity || 0) < 10;
      this.stepFormGroup.controls['lowerAlignersQuantity'].markAsTouched();
    }

    if (notMinimalQuantity)
    {
      this.stepFormGroup.controls.lowerAlignersQuantity.setErrors({
        notMinimalQuantity: true
      });
    }
    else
    {
      this.stepFormGroup.controls.lowerAlignersQuantity.setErrors(null);
    }

    return notMinimalQuantity;
  }

  private updateSetupCurrentStep(body: any)
  {
    this.setupDataService.updateSetupCurrentStep(body)
    .subscribe(()=>
    {
      this.setCurrentSetupStep(body.currentStep);
    });
  }

  
}
